/* eslint-disable no-unused-expressions */
import { useEffect, useState } from 'react'

const useDrag = ({ ref, onDragStart, onDragOver, onDragEnd }) => {
  const [dragState, setDragState] = useState('draggable')
  const dragStart = (ev) => {
    setDragState('dragStart')
    onDragStart && onDragStart(ev)
  }

  const dragOver = (ev) => {
    setDragState('dragOver')
    onDragOver && onDragOver()
    ev.preventDefault()
  }

  const dragEnd = () => {
    setDragState('dragEnd')
    onDragEnd && onDragEnd()
  }

  useEffect(() => {
    const elem = ref.current
    if (elem) {
      elem.addEventListener('dragstart', dragStart)
      elem.addEventListener('dragover', dragOver)
      elem.addEventListener('dragend', dragEnd)
      return () => {
        elem.removeEventListener('dragstart', dragStart)
        elem.removeEventListener('dragover', dragOver)
        elem.removeEventListener('dragend', dragEnd)
      }
    }
    return () => {}
  }, [])

  return {
    dragState,
  }
}

export default useDrag
